export const addOpacityToRGB = (rgb: string, opacity: number) => {
  const match = rgb.match(/\d+/g)

  if (match && match.length === 3) {
    const [r, g, b] = match.map(Number)
    return `rgba(${r}, ${g}, ${b}, ${opacity})`
  }
  return rgb
}
